import React from 'react';
import { useSelector } from 'react-redux';
import ErrorBubble from '../../CommonComponents/ErrorBubble';
import { Checkbox } from '../../CommonComponents/OPL/Checkbox/Checkbox';
import { selectHasFirmSettingsAccess } from '../../CommonSelectors/CommonAreaSelector';

const EditReportSave = props => {
  const {
    selectedReport,
    onChange,
    remove,
    put,
    dismiss,
    saving,
    errors,
    onCloseErrors,
    onChangeFirmLevel,
  } = props;

  const { name, isFirmLevelReport } = selectedReport;

  const hasFirmSettingsAccess = useSelector(selectHasFirmSettingsAccess);

  return (
    <div id="EditReport_Save">
      <h2 className="title">
        Save Report
        <i className="fa fa-times close" onClick={dismiss} />
      </h2>

      {selectedReport ? (
        <form className="adv-form">
          <ErrorBubble show={errors.length > 0} errors={errors} onHide={onCloseErrors} />
          <ul className="vertical-layout">
            <li>
              <label htmlFor="name">Name</label>
              <input
                type="text"
                className="md"
                value={name}
                id="name"
                onChange={e => onChange('name', e.target.value)}
              />
            </li>

            {hasFirmSettingsAccess && (
              <li style={{ paddingLeft: 200 }}>
                <Checkbox
                  checked={isFirmLevelReport}
                  onChange={evt => onChangeFirmLevel(evt.target.checked)}
                  helperText="Firm-level reports will be visible by all of the firm's advisors."
                >
                  Firm-Level Report
                </Checkbox>
              </li>
            )}
          </ul>
        </form>
      ) : null}

      <div className="actions">
        <button className="secondary dismiss lhs" id="btn-cancel" onClick={dismiss}>
          Cancel
        </button>
        <button
          className={saving ? 'green rhs loading' : 'green rhs'}
          disabled={saving}
          id="btn-save"
          onClick={put}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default EditReportSave;
